/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getLabPrescriptions } from 'app/entities/lab-prescription/lab-prescription.reducer';
import { getEntities as getRadiologyStudies } from 'app/entities/radiology-study/radiology-study.reducer';
import { getEntities as getParamedics } from 'app/entities/paramedic/paramedic.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { createEntity, getEntity, reset, updateEntity } from './paramedic-order.reducer';

export const ParamedicOrderUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const prescriptions = useAppSelector(state => state.prescription.entities);
  const labPrescriptions = useAppSelector(state => state.labPrescription.entities);
  const radiologyStudies = useAppSelector(state => state.radiologyStudy.entities);
  const paramedics = useAppSelector(state => state.paramedic.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const paramedicOrderEntity = useAppSelector(state => state.paramedicOrder.entity);
  const loading = useAppSelector(state => state.paramedicOrder.loading);
  const updating = useAppSelector(state => state.paramedicOrder.updating);
  const updateSuccess = useAppSelector(state => state.paramedicOrder.updateSuccess);
  const patientTypeValues = Object.keys(PatientType);

  const handleClose = () => {
    navigate(`/paramedic-order${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPrescriptions({}));
    dispatch(getLabPrescriptions({}));
    dispatch(getRadiologyStudies({}));
    dispatch(getParamedics({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...paramedicOrderEntity,
      ...values,
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      labPrescription: labPrescriptions.find(it => it.id.toString() === values.labPrescription?.toString()),
      radiologyStudy: radiologyStudies.find(it => it.id.toString() === values.radiologyStudy?.toString()),
      paramedic: paramedics.find(it => it.id.toString() === values.paramedic?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientType: 'OP',
          ...paramedicOrderEntity,
          prescription: paramedicOrderEntity?.prescription?.id,
          labPrescription: paramedicOrderEntity?.labPrescription?.id,
          radiologyStudy: paramedicOrderEntity?.radiologyStudy?.id,
          paramedic: paramedicOrderEntity?.paramedic?.id,
          patient: paramedicOrderEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.paramedicOrder.home.createOrEditLabel" data-cy="ParamedicOrderCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.paramedicOrder.home.createOrEditLabel">Create or edit a ParamedicOrder</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="paramedic-order-id"
                  label={translate('tinyMedicRestApp.paramedicOrder.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicOrder.active')}
                id="paramedic-order-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicOrder.cursor')}
                id="paramedic-order-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicOrder.lastUpdated')}
                id="paramedic-order-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicOrder.microSec')}
                id="paramedic-order-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicOrder.timestampEntry')}
                id="paramedic-order-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicOrder.patientType')}
                id="paramedic-order-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicOrder.visitId')}
                id="paramedic-order-visitId"
                name="visitId"
                data-cy="visitId"
                type="text"
              />
              <ValidatedField
                id="paramedic-order-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.paramedicOrder.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-order-labPrescription"
                name="labPrescription"
                data-cy="labPrescription"
                label={translate('tinyMedicRestApp.paramedicOrder.labPrescription')}
                type="select"
              >
                <option value="" key="0" />
                {labPrescriptions
                  ? labPrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-order-radiologyStudy"
                name="radiologyStudy"
                data-cy="radiologyStudy"
                label={translate('tinyMedicRestApp.paramedicOrder.radiologyStudy')}
                type="select"
              >
                <option value="" key="0" />
                {radiologyStudies
                  ? radiologyStudies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-order-paramedic"
                name="paramedic"
                data-cy="paramedic"
                label={translate('tinyMedicRestApp.paramedicOrder.paramedic')}
                type="select"
              >
                <option value="" key="0" />
                {paramedics
                  ? paramedics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-order-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.paramedicOrder.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/paramedic-order" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ParamedicOrderUpdate;
